import { render, staticRenderFns } from "./VaHorizontalBarChart.vue?vue&type=template&id=5fdf1d66&scoped=true&"
import script from "./VaHorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./VaHorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./VaHorizontalBarChart.vue?vue&type=style&index=0&id=5fdf1d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf1d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdf1d66')) {
      api.createRecord('5fdf1d66', component.options)
    } else {
      api.reload('5fdf1d66', component.options)
    }
    module.hot.accept("./VaHorizontalBarChart.vue?vue&type=template&id=5fdf1d66&scoped=true&", function () {
      api.rerender('5fdf1d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/charts/VaHorizontalBarChart.vue"
export default component.exports